/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Body.css";
import content from '../content.json';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import LoanOfficer from "../LoanOfficer/index.js";
import axios from "axios";

export default function Banner({dataJson, newData}) {

  
  const imgCDNURL = process.env.REACT_APP_HOMEOWNERSHIP_PROGRAM_CDN_URL;
  // const loInfo = loData.find(lo => lo.url === loName);
  const [loInfo, setLoInfo] = useState(null); // Initialize loInfo as null
  const [loanOfficerUid, setLoanOfficerUid] = useState('');
  const { agentName } = useParams();
  const agentJsonName = agentName + ".json";
  const [loading, setLoading] = useState(true);
  const [loadBodyData, setLoadBodyData] = useState(true);
  const [agentData, setAgentData] = useState();
  const [loanOfficerActive, setLoanOfficerActive] = useState(true);
  const [loanOfficerData, setLoanOfficerData] = useState();
  const [realorData, setRealtorData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [angelAiUserInfo, setAngelAiUserInfo] = useState();
  const [data, setData] = useState(null); // Set initial state as null




  const {title, title2, title3, titleMobile, title2Mobile, title3Mobile, btnName, para } = dataJson;
  
  return (
    <>
      <div className="banner">
        <Container>
          <Row className="banner-row">
            <Col sm={12} md={12} lg={7} className='welcome-col'>
              <h1 className='title'>{parse(title)}<img src={imgCDNURL +"five-star.webp"} className='five-star'></img></h1>
              <h1 className='titleMobile'>{parse(titleMobile)}</h1>
              <h2 className='title2'>{parse(title2)}</h2>
              <h2 className='title2Mobile'>{parse(title2Mobile)}</h2>
              <h2 className='title3'> {parse(title3)}<img 
    src={imgCDNURL + "home-layer.webp"} 
    className={newData ? 'home-layer' : 'home-layer-main'}
  /></h2>
              <h2 className='title3Mobile'>{parse(title3Mobile)}</h2>
              <p className='para'>{parse(para)}</p>
              </Col>
           <Col sm={12} md={12} lg={5} className='Loanofficer-col'>
           <Suspense fallback={<div />}>
                      <LoanOfficer
                        // realtorData={realorData}
                        // loanOfficerActive={loanOfficerActive}
                        // loanOfficerData={loanOfficerData}
                        // angelAiUserInfo={angelAiUserInfo}
                        newData = {newData}
                      />
                    </Suspense>
           </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
